import React, { useState, useRef, useEffect } from 'react';
import { ChatContainer, ChatButton, ChatWindow, MessageList, MessageItem, InputContainer, SendButton } from './ChatBot.styled';
import { chatService } from '../../services/chatService';

interface Message {
  role: 'user' | 'assistant';
  content: string;
}

export const ChatBot: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState<Message[]>([]);
  const [inputMessage, setInputMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const messagesEndRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSendMessage = async () => {
    if (!inputMessage.trim()) return;

    const userMessage: Message = {
      role: 'user',
      content: inputMessage.trim()
    };

    setMessages(prev => [...prev, userMessage]);
    setInputMessage('');
    setIsLoading(true);

    try {
      const response = await chatService.sendMessage(userMessage.content);
      const assistantMessage: Message = {
        role: 'assistant',
        content: response
      };
      setMessages(prev => [...prev, assistantMessage]);
    } catch (error) {
      console.error('Failed to get response:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ChatContainer>
      <ChatButton onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? '×' : '💬'}
      </ChatButton>
      
      {isOpen && (
        <ChatWindow>
          <MessageList>
            {messages.map((message, index) => (
              <MessageItem key={index} role={message.role}>
                {message.content}
              </MessageItem>
            ))}
            {isLoading && <MessageItem role="assistant">...</MessageItem>}
            <div ref={messagesEndRef} />
          </MessageList>
          
          <InputContainer>
            <input
              type="text"
              value={inputMessage}
              onChange={(e) => setInputMessage(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
              placeholder="Type your message..."
            />
            <SendButton onClick={handleSendMessage} disabled={isLoading}>
              Send
            </SendButton>
          </InputContainer>
        </ChatWindow>
      )}
    </ChatContainer>
  );
}; 
